import api from './api';

export const statisticsService = {
  async getQuotesTimeline({ period = 'week', startIso, endIso } = {}) {
    const params = {};
    if (startIso) params.start = startIso;
    if (endIso) params.end = endIso;
    if (!startIso || !endIso) params.period = period;

    const response = await api.get('/statistics/quotes-timeline', { params });
    return response.data;
  },

  async getDashboardSummary({ startIso, endIso } = {}) {
    const params = {};
    if (startIso) params.start = startIso;
    if (endIso) params.end = endIso;

    const response = await api.get('/statistics/dashboard-summary', { params });
    return response.data;
  },

  async getQuotesByOccasion({ startIso, endIso } = {}) {
    const params = {};
    if (startIso) params.start = startIso;
    if (endIso) params.end = endIso;

    const response = await api.get('/statistics/quotes-by-occasion', { params });
    return response.data;
  },

  async getAddonsByOccasion({ occasion, delivery, menu } = {}) {
    const params = {};
    if (occasion && occasion !== 'all') params.occasion = occasion;
    if (delivery && delivery !== 'all') params.delivery = delivery;
    if (menu && menu !== 'all') params.menu = menu;

    const response = await api.get('/statistics/addons-by-occasion', { params });
    return response.data;
  },

  async getMenuNames() {
    const response = await api.get('/statistics/menu-names');
    return response.data;
  },

  async getCartsByOccasion({ occasion, delivery } = {}) {
    const params = {};
    if (occasion && occasion !== 'all') params.occasion = occasion;
    if (delivery && delivery !== 'all') params.delivery = delivery;

    const response = await api.get('/statistics/carts-by-occasion', { params });
    return response.data;
  },

  async getQuotesByMenu({ startIso, endIso, occasion, delivery } = {}) {
    const params = {};
    if (startIso) params.start = startIso;
    if (endIso) params.end = endIso;
    if (occasion && occasion !== 'all') params.occasion = occasion;
    if (delivery && delivery !== 'all') params.delivery = delivery;

    const response = await api.get('/statistics/quotes-by-menu', { params });
    return response.data;
  },

  async getQuotesByDelivery({ startIso, endIso } = {}) {
    const params = {};
    if (startIso) params.start = startIso;
    if (endIso) params.end = endIso;

    const response = await api.get('/statistics/quotes-by-delivery', { params });
    return response.data;
  },

  async getQuotesByMonth() {
    const response = await api.get('/statistics/quotes-by-month');
    return response.data;
  },

  async getComebackOfferStatistics({ period = 'week', startIso, endIso } = {}) {
    const params = {};
    if (startIso) params.start = startIso;
    if (endIso) params.end = endIso;
    if (!startIso || !endIso) params.period = period;

    const response = await api.get('/statistics/comeback-offers', { params });
    return response.data;
  }
};
